<script lang="ts">
	import { MailProtocolStatus } from './MailProtocol.model'
	import Badge from '$lib/atoms/Badge.svelte'
	import { t } from '$i18n/i18n'
	import Tooltip from '$lib/atoms/Tooltip.svelte'

	interface MailStatusBadgeProps {
		status: MailProtocolStatus
		statusMessage: string
	}

	let { status, statusMessage }: MailStatusBadgeProps = $props()

	let { text, color, backgroundColor } = $derived.by(() => {
		let text, backgroundColor, color
		switch (status) {
			case MailProtocolStatus.DELIVERED:
				text = $t('UI.mail.protocol.status.delivered')
				backgroundColor = '#D5FFDC'
				color = '#58C079'
				break
			case MailProtocolStatus.FAILED:
				text = $t('UI.mail.protocol.status.failed')
				backgroundColor = '#FFD5D5'
				color = '#C05858'
				break
			case MailProtocolStatus.PENDING:
				text = $t('UI.mail.protocol.status.pending')
				backgroundColor = '#C6D2FC'
				color = '#4068F4'
		}
		return { text, color, backgroundColor }
	})
</script>

{#if statusMessage}
	<Tooltip msg={statusMessage}>
		<Badge {text} {color} {backgroundColor} uppercase large />
	</Tooltip>
{:else}
	<Badge {text} {color} {backgroundColor} uppercase large />
{/if}
